import { ErrorType } from '../../types/error.type';

export type Unit = {
  unitId: string;
  unitName: string;
}

export type UnitListByBuildingId = {
  buildingId: string,
  listOfUnits?: Unit[]
  errors?: ErrorType[]
}

export type GetUnitsByBuildingIdResponseDto = {
  getStoredUnitsByBuildingId: UnitListByBuildingId
}

export const GET_UNIT_LIST_BY_BUILDING_ID = (buildingId: string): string => `query GetStoredUnitsByBuildingId {
  getStoredUnitsByBuildingId(buildingId: "${buildingId}") {
    ... on getStoredUnitByBuildingOutput {
      buildingId,
      listOfUnits {
        unitName
      }
    }
    ... on ErrorListOutput {
      errors {
        id
        message
        type
      }
    }
  }
}`;
